import React from "react";
import { Link, useLocation } from "react-router-dom";

import { useRecoilValue, useRecoilValueLoadable } from "recoil";
import { signInState } from "lib/store/user";
import { asyncGetProject, currentProject } from "lib/store/project";

import { Button, NavList, Logo } from "@atsent/components";

import { Profile } from "components/atom/Profile";
import { ProjectAlarm, UserAlarm } from "components/template/Alarm";

import "./Header.scss";

export type HeaderProps = {};

const Logged = ({ current }: { current: string }) => {
  const pid = useRecoilValue(currentProject);

  const { state, contents } = useRecoilValueLoadable(asyncGetProject);

  return (
    <div className="button-wrapper">
      {!["/"].includes(current) &&
        state === "hasValue" &&
        !!contents?.analyzed_at && (
          <Button
            cx={"dashboard-button"}
            outline
            to={`/${pid}`}
            routerLink={Link}
            isNext
          >
            Dashboard
          </Button>
        )}
      {current === "/" ? <UserAlarm /> : <ProjectAlarm />}
      <Profile />
    </div>
  );
};

const NotLogged = ({ current }: { current: string }) => (
  <NavList
    routerLink={Link}
    current={current}
    list={[
      { link: "/sign-in", text: "로그인" },
      { link: "/sign-up", text: "회원가입" },
    ]}
  />
);

export const Header: React.FC<HeaderProps> = () => {
  const isLogged = useRecoilValue(signInState);
  const current = useLocation().pathname;
  return (
    <header className={"Header"}>
      <section>
        {["/sign-in", "/sign-up"].includes(current) ? (
          <Logo cx={"bgBlack"} />
        ) : (
          <Link to={"/"}>
            <Logo beta />
          </Link>
        )}

        {isLogged ? (
          <Logged current={current} />
        ) : (
          <NotLogged current={current} />
        )}
      </section>
    </header>
  );
};
